import { render, staticRenderFns } from "./ScientificActivityTab.vue?vue&type=template&id=1064a6e2&scoped=true"
import script from "./ScientificActivityTab.vue?vue&type=script&lang=js"
export * from "./ScientificActivityTab.vue?vue&type=script&lang=js"
import style0 from "./ScientificActivityTab.vue?vue&type=style&index=0&id=1064a6e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1064a6e2",
  null
  
)

export default component.exports